<div class="mt-2">
  <ng-container *ngTemplateOutlet="grid; context: { type: type }"></ng-container>
</div>

<ng-template #grid let-type="type">
  <dx-data-grid
    #dataGridRef
    *var="inEditMode$ | async as inEditMode"
    class="websites__data-grid"
    [class.ag-profile-grid__grid]="LayoutGridType.default !== type"
    [class.websites__data-grid--view]="!inEditMode"
    [dataSource]="websites"
    [showRowLines]="LayoutGridType.default === type"
    [showBorders]="LayoutGridType.default === type"
    [showColumnLines]="LayoutGridType.default === type"
    [showColumnHeaders]="LayoutGridType.default === type"
    [columnAutoWidth]="true"
    [wordWrapEnabled]="true"
    [rowAlternationEnabled]="false"
    [noDataText]="emptyMessage"
    (onRowRemoving)="onRowRemoving($event)"
    height="100%"
  >
    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <div class="toolbar-label">
            <b>{{ gridTitle }}</b>
          </div>
        </div>
      </dxi-item>

      @if (hasPermissionsToEdit) {
        <dxi-item
          [visible]="!inEditMode"
          location="after"
          widget="dxButton"
          locateInMenu="auto"
          [cssClass]="'ag-profile-grid__toolbar-button'"
        >
          <div *dxTemplate>
            <dx-button
              hint="ENABLE EDIT"
              icon="edit"
              stylingMode="text"
              [agMergeGuard]="parentDbId"
              (agMergeGuardedClick)="enableEditMode()"
            ></dx-button>
          </div>
        </dxi-item>

        <dxi-item
          [visible]="inEditMode"
          location="after"
          widget="dxButton"
          locateInMenu="auto"
          [cssClass]="'ag-profile-grid__toolbar-button'"
        >
          <div *dxTemplate>
            <dx-button
              hint="CANCEL EDIT"
              icon="undo"
              type="danger"
              stylingMode="text"
              (onClick)="disableEditMode()"
            ></dx-button>
          </div>
        </dxi-item>
      }

      @if (inEditMode && hasPermissionsToAdd) {
        <dxi-item
          location="after"
          widget="dxButton"
          [cssClass]="type !== LayoutGridType.default ? 'ag-profile-grid__toolbar-button' : ''"
        >
          <div *dxTemplate>
            <dx-button
              icon="plus"
              [stylingMode]="type !== LayoutGridType.default ? 'text' : 'outlined'"
              [agMergeGuard]="parentDbId"
              (agMergeGuardedClick)="handleEditWebsites($event)"
            ></dx-button>
          </div>
        </dxi-item>
      }
    </dxo-toolbar>

    <dxo-editing
      mode="row"
      [useIcons]="true"
      [allowUpdating]="hasPermissionsToEdit"
      [allowDeleting]="hasPermissionsToDelete"
      [allowAdding]="hasPermissionsToAdd"
    >
    </dxo-editing>

    <dxo-paging [enabled]="false"></dxo-paging>
    <dxo-scrolling [mode]="'virtual'" [showScrollbar]="'always'"></dxo-scrolling>

    <dxi-column
      [visible]="LayoutGridType.default !== type"
      [name]="'fullUrlAddress'"
      [caption]="''"
      cellTemplate="fullWebsiteCellTemplate"
      [width]="LayoutGridType.short === type ? '80%' : '50%'"
    >
      <div *dxTemplate="let cell of 'fullWebsiteCellTemplate'" class="ag-profile-grid__text-with-icons">
        <dx-button
          [elementAttr]="{ class: 'ag-profile-grid__button-link' }"
          [text]="cell?.data?.[WebsiteKeys.url]"
          [hint]="cell?.data?.[WebsiteKeys.url]"
          [type]="'default'"
          [stylingMode]="'text'"
          (onClick)="goToWebsite(cell?.data?.[WebsiteKeys.url])"
        ></dx-button>
      </div>
    </dxi-column>

    <dxi-column [dataField]="WebsiteKeys.url" [width]="'80%'" [visible]="LayoutGridType.default === type">
    </dxi-column>

    <dxi-column
      [dataField]="WebsiteKeys.websiteType"
      caption="Type"
      [editorOptions]="{ onSelectionChanged: onWebsiteTypeChanged }"
      cellTemplate="fullWebsiteTypeCellTemplate"
      [width]="'auto'"
    >
      <dxo-lookup
        [dataSource]="websiteTypesLookup"
        [displayExpr]="LookupKeys.description"
        [valueExpr]="BaseModelKeys.dbId"
      ></dxo-lookup>
      <div *dxTemplate="let cell of 'fullWebsiteTypeCellTemplate'" class="ag-profile-grid__text-with-icons">
        <i
          class="dx-icon ag-profile-grid__list-icon"
          [ngClass]="cell?.displayValue | businessPersonalTypeIcon"
          [title]="cell?.displayValue"
        ></i>
      </div>
    </dxi-column>

    <dxi-column type="buttons" [visible]="inEditMode" [width]="LayoutGridType.default !== type ? '95px' : undefined">
      <dxi-button icon="agi-copy" [cssClass]="'ag-profile-grid__col-button'" [onClick]="handleCopyWebsites"></dxi-button>
      <dxi-button icon="edit" [cssClass]="'ag-profile-grid__col-button'" [visible]="hasPermissionsToEdit" [onClick]="handleEditWebsites"></dxi-button>
      <dxi-button name="delete" icon="trash" [cssClass]="'ag-profile-grid__col-button'"></dxi-button>
    </dxi-column>
  </dx-data-grid>
</ng-template>

<ag-shr-modal-window
  #websiteEditorModalRef
  [title]="websiteModalTitle"
  [inProgress]="inProgress$ | async"
  [width]="'50vw'"
  [height]="'auto'"
  [saveButtonDisabled]="!hasWebsitesFormChanges"
  [onCloseModal]="handleWebsiteClosePopup"
  (onSaveClick)="handleWebsiteSave($event)"
>
  <ng-container *ngIf="websiteEditorModalRef?.popupComponent?.visible ?? false">
    <ag-shr-website-form
      #websiteFormRef
      [website]="websiteToEdit"
      [validationGroup]="websiteValidationGroup"
      [websitesTypesLookup]="websiteTypesLookup"
      (hasFormChanges)="hasWebsitesFormChanges=$event"
    ></ag-shr-website-form>
  </ng-container>
</ag-shr-modal-window>
